import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AbilitiesSelectors } from '@recruitee/abilities/data';
import { Ability, BillingPlanTier } from '@recruitee/http/types';
import { DialogComponentI, DialogRef } from '@recruitee/user-interface';

import { FeatureGuardFacade } from '../feature-guard.facade';
import { FeatureData, FeaturesGuardModel } from '../feature-guard.model';
import { GuardedFeature } from '../feature-guard.types';

@Component({
  selector: 'rt-feature-guard-dialog',
  templateUrl: './feature-guard-dialog.component.html',
  styleUrls: ['./feature-guard-dialog.component.less'],
})
export class FeatureGuardDialogComponent implements DialogComponentI<any, any> {
  public featureData: FeatureData;
  public feature: GuardedFeature;
  public canUpgrade: boolean = false;
  public BillingPlanTier: typeof BillingPlanTier = BillingPlanTier;
  public availableFromPlan: BillingPlanTier | null;
  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private model: FeaturesGuardModel,
    private dialogRef: DialogRef,
    private cdRef: ChangeDetectorRef,
    private store: Store,
    private guardFacade: FeatureGuardFacade,
  ) {}

  public ngOnInit(): void {
    this.store
      .pipe(
        select(AbilitiesSelectors.hasOne(Ability.ManageSubscription)),
        takeUntil(this.ngOnDestroy$.asObservable()),
      )
      .subscribe(enabled => {
        this.canUpgrade = enabled;
        this.cdRef.detectChanges();
      });

    this.guardFacade
      .getPlanWhereFeatureIsAvailable(this.feature)
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(availableFromPlan => {
        this.availableFromPlan = availableFromPlan;
        this.cdRef.detectChanges();
      });

    if (this.featureData.analytics) {
      this.featureData.analytics.discrimination();
    }
  }

  public setDialogData({ feature }: { feature: GuardedFeature }): void {
    if (feature) {
      this.feature = feature;
      this.featureData = this.model.data[feature];
    }
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
  public openPlanPicker(): void {
    if (this.featureData.analytics) {
      this.featureData.analytics.cta();
    }
    this.dialogRef.close();
    this.router.navigate([{ outlets: { dialog: ['order', 'select-product'] } }]);
  }

  public get hasBadge(): boolean {
    return (
      this.availableFromPlan === BillingPlanTier.Scale ||
      this.availableFromPlan === BillingPlanTier.Lead ||
      this.availableFromPlan === BillingPlanTier.Grow ||
      this.availableFromPlan === BillingPlanTier.Optimize
    );
  }
}
